import React, { useContext } from "react";
import { Link, Outlet } from "react-router-dom";
import { EnvContext } from "../../context/EnvContext";

const ShippingOptions = () => {
  const environment = useContext(EnvContext);

  const styles = {
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px",
      borderBottom: "1px solid #e0e0e0",
      backgroundColor: "#ffffff",
    },
    buttonGroup: {
      display: "flex",
      gap: "10px",
    },
    button: {
      padding: "0px",
      width: "120px",
      backgroundColor: "#478169",
      color: "white",
      border: "none",
      borderRadius: 5,
      cursor: "pointer",
      fontSize: "14px",
      height: "50px",
      transition: "background-color 0.3s",
    },
    stagingBadge: {
      fontSize: "12px",
      color: "#ff9800",
      marginLeft: "10px",
    },
  };

  return (
    <div>
      <div style={styles.header}>
        <h2>
          Shipping Options
          {environment === "staging" && (
            <span style={styles.stagingBadge}>(Staging)</span>
          )}
        </h2>
        <div style={styles.buttonGroup}>
          <Link to="/main/shipping-options/new">
            <button style={styles.button}>New Shipping</button>
          </Link>
        </div>
      </div>
      <div style={{ padding: "10px" }}>
        <Outlet />
      </div>
    </div>
  );
};

export default ShippingOptions;
